import React, { type FC } from 'react';
import { t } from '../../../../utils/i18n';
import { DH } from '../../../../utils/dataHooks';
import { st, classes } from './styles.st.css';

export const Divider: FC = () => (
  <div className={st(classes.root)} data-hook={DH.Widget.HorizontalLayoutDivider}>
    <span className={st(classes.line)} />
    <span className={st(classes.text)}>{t('horizontalLayout.dividerText')}</span>
    <span className={st(classes.line)} />
  </div>
);
